import script from "./IncidentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./IncidentCard.vue?vue&type=script&setup=true&lang=js"

import "./IncidentCard.vue?vue&type=style&index=0&id=0e39b682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e39b682"]])

export default __exports__